import {setAxiosConfig} from './axios';

// export function setUserAgent(agent) {
//   setAxiosConfig({ headers: { 'User-Agent': agent } });
// }

export function setDevice(device) {
  setAxiosConfig({ headers: { X_API_DEVICE: device } });
}

// export function setNonce(nonce) {
//   setAxiosConfig({ headers: { 'X-API-NONCE':  nonce} });
// }
